import { FahrlehrerCh } from '@/src/@types/blinkadmin'

export type Teacher = FahrlehrerCh.LocationPageTeacher

/** Always-offered gender options, shown even when no teacher matches them. */
export const GENDER_OPTIONS = ['männlich', 'weiblich', 'divers']

export function genderLabel(teacher: Teacher): string | null {
  return teacher.gender ? teacher.gender.toLowerCase() : null
}

export const EXPERIENCE_ORDER = ['0-4 Jahre', '5-10 Jahre', '10+ Jahre']

export function experienceBucket(teacher: Teacher): string | null {
  if (!teacher.certificationSince) return null
  const years = new Date().getFullYear() - teacher.certificationSince
  if (years <= 4) return EXPERIENCE_ORDER[0]
  if (years <= 10) return EXPERIENCE_ORDER[1]
  return EXPERIENCE_ORDER[2]
}

export const GEARBOX_OPTIONS = ['Geschalten', 'Automat']

export function gearboxLabels(teacher: Teacher): string[] {
  const labels: string[] = []
  if (teacher.teacherCategories.includes('BM')) labels.push('Geschalten')
  if (teacher.teacherCategories.includes('BA')) labels.push('Automat')
  return labels
}
